module.exports = __webpack_public_path__ + "img/terroir-grid-3.25f0d5a0.jpg";